import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'

import TimetoastPropTypes from '../../../../constants/timetoast_prop_types'
import { defaultColorScheme } from '@helpers/color_scheme_helpers.js'

import ColorSchemeEditor from './color_scheme_editor'
import ColorSchemePreview from './color_scheme_preview'

export default class ColorSchemeCustomizer extends Component {
  handleChange = colorScheme => {
    const { onChange } = this.props
    onChange(colorScheme)
  }

  render() {
    const { colorScheme } = this.props
    return (
      <div className="color-scheme-customizer">
        <div className="color-scheme-customizer__color-palette">
          <ColorSchemeEditor colorScheme={colorScheme} onChange={this.handleChange} />
        </div>
        <h2 className="heading zeta">Mini-preview</h2>
        <div className="color-scheme-customizer__preview">
          <ColorSchemePreview colorScheme={colorScheme} />
        </div>
      </div>
    )
  }
}
ColorSchemeCustomizer.propTypes = {
  colorScheme: TimetoastPropTypes.colorScheme.isRequired,
  onChange: PropTypes.func.isRequired,
}
ColorSchemeCustomizer.defaultProps = {
  colorScheme: defaultColorScheme(),
  onChange: noop,
}
